import { InfoReturnOptions, InfoSupplier } from 'src/features/receivement/ReceivementTypes'

interface Action {
    name: string;
    description?: string;
}

export const getReceivementAgreementInfo = (info: InfoReturnOptions) => {
  let infoSupplier = ''

  let possibleActions: Action[] = []

  const {
    allowBreakUnitOnInvoiceReturn,
    allowInvoiceReturn,
    allowPartialReturn,
  } = info

  if (!allowInvoiceReturn) {
    infoSupplier = InfoSupplier.NOT_ACCEPT_NFD
    possibleActions = [
      {
        name: 'Rejeitar tudo:',
        description: 'Ao rejeitar um produto, todos os demais produtos da nota serão automaticamente rejeitados;',
      },
      {
        name: 'Aceitar tudo:',
        description: 'Aceita todos os produtos da nota.',
      },
    ]
  } else if (!allowPartialReturn) {
    infoSupplier = InfoSupplier.ACCEPT_NFD
    possibleActions = [
      {
        name: 'Rejeitar tudo:',
        description: 'Ao rejeitar um produto, todos os demais produtos da nota serão automaticamente rejeitados;',
      },
      {
        name: 'Aceitar tudo:',
        description: 'Aceita todos os produtos da nota.',
      },
    ]
  } else if (!allowBreakUnitOnInvoiceReturn) {
    infoSupplier = InfoSupplier.RETURN_BY_BOXES
    possibleActions = [
      {
        name: 'Aceitar sem avarias;',
      },
      {
        name: 'Aceitar com avarias:',
        description: 'a "Qtd. Aceita" deve respeitar a caixaria do produto;',
      },
      {
        name: 'Parcial:',
        description: 'a "Qtd. Aceita" deve respeitar a caixaria do produto;',
      },
      {
        name: 'Aceitar máximo:',
        description: 'aceita a quantidade máxima possível devolvendo todas as avarias em caixas completas;',
      },
      {
        name: 'Rejeitar tudo.',
      },
    ]
  } else {
    infoSupplier = InfoSupplier.RETURN_BY_UNIT
    possibleActions = [
      {
        name: 'Aceitar sem avarias;',
      },
      {
        name: 'Aceitar com avarias;',
      },
      {
        name: 'Parcial;',
      },
      {
        name: 'Rejeitar tudo.',
      },
    ]
  }

  return { infoSupplier, possibleActions }
}
